// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/modals/channel_tabs/ChannelOverviewTab.module.css';
import type {ExtendedSingleValueProps} from '@app/features/channel/components/modals/channel_tabs/channel_overview_tab/shared';
import * as EmojiUtils from '@app/features/expressions/utils/EmojiUtils';
import {observer} from 'mobx-react-lite';
import {components} from 'react-select';

export const RtcRegionSingleValue = observer((props: ExtendedSingleValueProps) => {
	const {region, label} = props.data;
	if (!region) {
		return (
			<components.SingleValue
				data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.components-single-value"
				{...props}
			>
				<span data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.span">{label}</span>
			</components.SingleValue>
		);
	}
	const displayName = props.getRegionDisplayName(region.id, region.name);
	return (
		<components.SingleValue
			data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.components-single-value--2"
			{...props}
		>
			<div
				className={styles.regionOption}
				data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.region-option"
			>
				<img
					src={EmojiUtils.getEmojiURL(region.emoji) ?? undefined}
					alt={displayName}
					className={styles.regionEmoji}
					data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.region-emoji"
				/>
				<span data-flx="channel.channel-tabs.channel-overview-tab.rtc-region-single-value.span--2">{displayName}</span>
			</div>
		</components.SingleValue>
	);
});
